import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dialog-content" }
const _hoisted_2 = { class: "gutter-y-s3" }
const _hoisted_3 = { class: "caption" }
const _hoisted_4 = { class: "flex dialog-detail align-items-center justify-content-between mt-s2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted mx-s1" }, "/", -1)
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = { class: "caption" }
const _hoisted_8 = { class: "dialog-data mt-s2 flex-center" }
const _hoisted_9 = {
  key: 1,
  class: "flex-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted mx-s1" }, "/", -1)
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "caption" }
const _hoisted_14 = { class: "mr-s1" }
const _hoisted_15 = { class: "text-default" }
const _hoisted_16 = {
  key: 0,
  class: "flex text-sm panel-info align-items-center justify-content-between py-s2 mt-s2"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, "1234", -1)
const _hoisted_18 = { class: "dialog-footer dialog-footer-two-btn" }

import { useI18n } from 'vue-i18n';
import { TokenAmount } from '@/sdk/entities/fractions/tokenAmount';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { safeParseUnits } from '@/helpers/utils';
import { ref, computed } from 'vue';
import PriceImpactErrorMessage from '@/views/pages/liquidity/single-side/components/PriceImpactErrorMessage.vue';
import Caption from '@/components/Caption.vue';
import { SingleSideDepositForm } from '@/store/modules/single-side/models/single-side-deposit-form';
import { format, printUSD } from '@/utils/format';
import BigNumber from 'bignumber.js';
import LossConfirmationDialog from '@/views/pages/liquidity/single-side/components/LossConfirmationDialog.vue';
import LpAmountFormat from '@/components/LpAmountFormat.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenDepositConfirmation',
  props: {
    tokenForm: null
  },
  emits: ["cancel", "confirm"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'cancel'): void;
  (e: 'confirm'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  tokenForm: SingleSideDepositForm;
}





const { t } = useI18n();
const amountStrToSignificant = (token, amount) => {
  return new TokenAmount(token, safeParseUnits(amount, token.decimals)).toSignificant(8);
};

const isRequestInProgress = computed(() => props.tokenForm.isEstimateDepositRequestInProgress);
const isPriceImpactError = computed(() => {
  return !!props.tokenForm.errors['PRICE_IMPACT'];
});
const isCrosschain = computed(() => props.tokenForm.input.token?.isCrossChain);
const isNeedLossConfirmation = computed(() => !!props.tokenForm.errors['HUGE_LOSS']);
const lossPanelClass = computed(() => (isNeedLossConfirmation.value ? 'warning' : 'success'));
const isLoss = computed(() => !props.tokenForm.lossInUSD.eq(0));
const isLossConfirmationDialog = ref(false);

const formatValueToPrint = (value: BigNumber, currency) => {
  const isValueTooSmall = value.lt(0.01);
  return isValueTooSmall ? `<0.01 ${currency}` : `${format(value)} ${currency}`;
};

const onConfirm = () => {
  emits('confirm');
};
const onShowLossConfirmation = () => {
  isLossConfirmationDialog.value = true;
};
const onClickConfirm = () => {
  isNeedLossConfirmation.value ? onShowLossConfirmation() : onConfirm();
};

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('singleSide.confirmDialog.deposit.youProvide')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TokenIcon, {
              "icon-src": __props.tokenForm.input.token?.portfolioToken.tokenIconUrl,
              symbol: __props.tokenForm.input.token?.portfolioToken.symbol,
              "chain-id": __props.tokenForm.input.token?.portfolioToken.chainId,
              size: "20",
              full: ""
            }, null, 8, ["icon-src", "symbol", "chain-id"]),
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(amountStrToSignificant(__props.tokenForm.input.token?.portfolioToken, __props.tokenForm.input.amount)), 1),
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(printUSD)(__props.tokenForm.estimatedDepositInUSD)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('singleSide.confirmDialog.deposit.lpTokensToFarm')), 1),
          _createElementVNode("div", _hoisted_8, [
            (_unref(isRequestInProgress))
              ? (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 0,
                  class: "w-8rem"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(LpAmountFormat, {
                    "lp-amount": __props.tokenForm.estimatedDepositInLP
                  }, null, 8, ["lp-amount"]),
                  _hoisted_10,
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(printUSD)(__props.tokenForm.estimatedDepositInUSD)), 1)
                ]))
          ])
        ]),
        (_unref(isLoss))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('singleSide.confirmDialog.fee')), 1),
              (_unref(isPriceImpactError))
                ? (_openBlock(), _createBlock(PriceImpactErrorMessage, {
                    key: 0,
                    class: "mt-s2"
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`panel-message-${_unref(lossPanelClass)} flex align-items-center justify-content-between mt-s2`)
                    }, [
                      _createElementVNode("div", null, _toDisplayString(_unref(t)('singleSide.confirmDialog.feeAndPriceImpact')), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(printUSD)(__props.tokenForm.lossInUSD)), 1),
                        _createElementVNode("span", _hoisted_15, "(" + _toDisplayString(formatValueToPrint(__props.tokenForm.lossPercent, '%')) + ") ", 1)
                      ])
                    ], 2),
                    (_unref(isCrosschain))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(Caption, {
                            caption: _unref(t)('singleSide.confirmDialog.crosschainFee.caption'),
                            tooltip: _unref(t)('singleSide.confirmDialog.crosschainFee.tooltip')
                          }, null, 8, ["caption", "tooltip"]),
                          _hoisted_17
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_Button, {
        class: "button-base",
        label: _unref(t)('cancel'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('cancel')))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "button-primary",
        label: _unref(t)('singleSide.confirmDialog.deposit.confirmButtonLabel'),
        disabled: _unref(isPriceImpactError),
        onClick: onClickConfirm
      }, null, 8, ["label", "disabled"])
    ]),
    (isLossConfirmationDialog.value)
      ? (_openBlock(), _createBlock(LossConfirmationDialog, {
          key: 0,
          onConfirm: _cache[1] || (_cache[1] = ($event: any) => (onConfirm())),
          "price-impact": _unref(format)(__props.tokenForm.lossPercent),
          "totally-provide": _unref(format)(__props.tokenForm.estimatedDepositInUSD),
          "potential-loss": _unref(format)(__props.tokenForm.lossInUSD)
        }, null, 8, ["price-impact", "totally-provide", "potential-loss"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})